import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';
import { routesList } from './routesList';

export const AppRoutes: React.FunctionComponent = () => (
    <Suspense fallback={'Loading'}>
        <Routes>
            <Route path="/">
                {Object.entries(routesList).map(([key, route]) => (
                    <Route
                        key={key}
                        path={route.path}
                        element={
                            <PrivateRoute {...route}>
                                <Suspense fallback={<div>Loading...</div>}>
                                    <route.component />
                                </Suspense>
                            </PrivateRoute>
                        }
                    />
                ))}
            </Route>
        </Routes>
    </Suspense>
);
